import { useEffect, useState } from 'react';
import { navLinks, updateList } from '@/mocks/homeData';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const marqueeItems = [...updateList, ...updateList];

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="bg-primary-600 text-background-50">
        <div className="flex h-8 items-center gap-3 px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1 font-label text-xs font-medium">
            <i className="ri-flashlight-line text-sm" aria-hidden="true"></i>
            更新条
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-8">
              {marqueeItems.map((item, index) => (
                <span
                  key={`${item.date}-${index}`}
                  className="flex items-center gap-2 whitespace-nowrap text-xs text-background-50/90"
                >
                  <span className="rounded-full bg-background-50/20 px-1.5 py-0.5 text-[10px]">
                    {item.type}
                  </span>
                  <span className="font-medium">{item.date}</span>
                  <span>{item.title}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`transition-colors duration-300 ${
          scrolled
            ? 'border-b border-background-200/80 bg-background-50/95 backdrop-blur'
            : 'border-b border-transparent bg-transparent'
        }`}
      >
        <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-6">
          <button
            type="button"
            onClick={() => goTo('top')}
            className="flex cursor-pointer items-center gap-2.5"
            aria-label="回到页面顶部"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-book-2-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col items-start leading-tight">
              <span
                className={`font-heading text-base font-bold ${
                  scrolled ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                善良的女秘书
              </span>
              <span
                className={`text-[11px] ${
                  scrolled ? 'text-foreground-500' : 'text-background-100/80'
                }`}
              >
                中文字幕 · 译制版本导览
              </span>
            </span>
          </button>

          <nav className="hidden items-center gap-1 md:flex" aria-label="页内导航">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => goTo(link.id)}
                className={`cursor-pointer rounded-md px-3 py-2 text-sm transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                    : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => goTo('episodes')}
              className="hidden cursor-pointer rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 lg:inline-flex"
            >
              浏览分集字幕
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md transition-colors md:hidden ${
                scrolled
                  ? 'text-foreground-800 hover:bg-background-100'
                  : 'text-background-50 hover:bg-background-50/15'
              }`}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200/80 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  type="button"
                  onClick={() => goTo(link.id)}
                  className="cursor-pointer rounded-md px-3 py-2.5 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </button>
              ))}
              <button
                type="button"
                onClick={() => goTo('episodes')}
                className="mt-1 cursor-pointer rounded-md bg-primary-500 px-3 py-2.5 text-left text-sm font-medium text-background-50"
              >
                浏览分集字幕
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}